module.exports = __webpack_public_path__ + "img/arrow-angle-down-purple.291f087d.svg";